import React, { ButtonHTMLAttributes, DetailedHTMLProps } from 'react';
import styles from '../../../styles/logpost.module.css';
import CaretDown from '../../../assets/icons/CaretDown';

function LoadMoreButton(props: DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>) {
  return (
    <button type="button" {...props} className={styles.loadMoreButton}>
      View Older Posts <CaretDown />
    </button>
  );
}

export default LoadMoreButton;
